import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { BodyPublicComponent } from './publico/body-public/body-public.component';
import { PrincipalPublicComponent } from './publico/principal-public/principal-public.component';
import { IngresoPublicComponent } from './publico/ingreso-public/ingreso-public.component';

import { BodyAdminComponent } from './administrar/body-admin/body-admin.component';
import { PrincipalAdminComponent } from './administrar/principal-admin/principal-admin.component';
import { UsuariosAdminComponent } from './administrar/usuarios-admin/usuarios-admin.component';
import { RolesAdminComponent } from './administrar/roles-admin/roles-admin.component';
import { EstadosAdminComponent } from './administrar/estados-admin/estados-admin.component';
import { PermisoCrearAdminComponent } from './administrar/permiso-crear-admin/permiso-crear-admin.component';
import { PermisoAsignaAdminComponent } from './administrar/permiso-asigna-admin/permiso-asigna-admin.component';
import { ModulosAdminComponent } from './administrar/modulos-admin/modulos-admin.component';

import { BodyOperarioComponent } from './operario/body-operario/body-operario.component';
import { PrincipalOperarioComponent } from './operario/principal-operario/principal-operario.component';
import { ReqGeneralOperarioComponent } from './operario/req-general-operario/req-general-operario.component';
import { ReqEspecificoOperarioComponent } from './operario/req-especifico-operario/req-especifico-operario.component';
import { BecasTipoOperarioComponent } from './operario/becas-tipo-operario/becas-tipo-operario.component';
import { RequisitoTipoOperarioComponent } from './operario/requisito-tipo-operario/requisito-tipo-operario.component';
import { BecasDetalleOperarioComponent } from './operario/becas-detalle-operario/becas-detalle-operario.component';
import { CalificacionesOperarioComponent } from './operario/calificaciones-operario/calificaciones-operario.component';
import { ReqEspecificoOperarioVerComponent } from './operario/req-especifico-operario-ver/req-especifico-operario-ver.component';
import { ReqGeneralOperarioVerComponent } from './operario/req-general-operario-ver/req-general-operario-ver.component';
import { ListaBecariosComponent } from './operario/lista-becarios/lista-becarios.component';
import { PromedioOperarioComponent } from './operario/promedio-operario/promedio-operario.component';

import { BodyBecarioComponent } from './becario/body-becario/body-becario.component';
import { PrincipalBecarioComponent } from './becario/principal-becario/principal-becario.component';
import { VerBecasBecarioComponent } from './becario/ver-becas-becario/ver-becas-becario.component';
import { PostulaBecarioComponent } from './becario/postula-becario/postula-becario.component';
import { PostulaVerBecarioComponent } from './becario/postula-ver-becario/postula-ver-becario.component';
import { FichaEstudianteComponent } from './becario/ficha-estudiante/ficha-estudiante.component';
import { FichaListaComponent } from './becario/ficha-lista/ficha-lista.component';
import { FichaRespuestaComponent } from './becario/ficha-respuesta/ficha-respuesta.component';
import { FichaEditarComponent } from './becario/ficha-editar/ficha-editar.component';
import { EncuestaReporteComponent } from './operario/encuesta-reporte/encuesta-reporte.component';

import { EducativaConsultasComponent } from './operario/educativa-consultas/educativa-consultas.component';
import { EducativaReservaComponent } from './operario/educativa-reserva/educativa-reserva.component';
import { EducativaInfAtencionesComponent } from './operario/educativa-inf-atenciones/educativa-inf-atenciones.component';
import { SimuladorAdminARComponent } from './operario/simulador-admin-ar/simulador-admin-ar.component';
import { EncuestaPreguntaComponent } from './operario/encuesta-pregunta/encuesta-pregunta.component';
import { EncuestaGrupoComponent } from './operario/encuesta-grupo/encuesta-grupo.component';
import { EncuestaComponent } from './operario/encuesta/encuesta.component';
import { EncuestaListaRespondeComponent } from './operario/encuesta-lista-responde/encuesta-lista-responde.component';
import { EncuestaRespuestaComponent } from './operario/encuesta-respuesta/encuesta-respuesta.component';
import { EncuestaMatrizComponent } from './operario/encuesta-matriz/encuesta-matriz.component';
import { EncuestaMatrizResultadoComponent } from './operario/encuesta-matriz-resultado/encuesta-matriz-resultado.component';
import { Calificaciones23OperarioComponent } from './operario/calificaciones23-operario/calificaciones23-operario.component';
import { SimuladorAR2023ComponentComponent } from './operario/simulador-ar2023-component/simulador-ar2023-component.component';
import { EstudioSocioEconomicoComponent } from "./operario/estudio-socio-economico/estudio-socio-economico.component";
import { EstudioSocioEconomico2025Component } from './operario/estudio-socio-economico2025/estudio-socio-economico2025.component';
import { EducativaReservaListaComponent } from './operario/educativa-reserva-lista/educativa-reserva-lista.component';
import { TipoBecaAjusteComponent } from './operario/tipo-beca-ajuste/tipo-beca-ajuste.component';
import { EstudioSocioEcRevisaComponent } from './operario/estudio-socio-ec-revisa/estudio-socio-ec-revisa.component';
import { EstudioSocioEcListaComponent } from './operario/estudio-socio-ec-lista/estudio-socio-ec-lista.component';
import { Calificaciones24OperarioComponent } from './operario/calificaciones24-operario/calificaciones24-operario.component';
import { Calificaciones25Component } from './operario/calificaciones25/calificaciones25.component';
import { SimuladorAr2025Component } from './operario/simulador-ar2025/simulador-ar2025.component';
import { FichaCustionariosComponent } from './operario/ficha-custionarios/ficha-custionarios.component';
import { FichaPreguntasComponent } from './operario/ficha-preguntas/ficha-preguntas.component';
import { FichaRespondeEstudianteComponent } from './becario/ficha-responde-estudiante/ficha-responde-estudiante.component';
import { EncuestaListaFaltantesComponent } from './operario/encuesta-lista-faltantes/encuesta-lista-faltantes.component';

const appRoutes: Routes = [
  {
    path: '',
    component: PrincipalPublicComponent,
    children: [
      {
        path: '',
        component: BodyPublicComponent
      },
      {
        path: 'ingreso',
        component: IngresoPublicComponent
      }
    ]
  },
  {
    path: 'inicio',
    component: PrincipalAdminComponent,
    children: [
      {
        path: '',
        component: BodyAdminComponent
      },
      {
        path: 'usuario',
        component: UsuariosAdminComponent
      },
      {
        path: 'roles',
        component: RolesAdminComponent
      },
      {
        path: 'estados',
        component: EstadosAdminComponent
      },
      {
        path: 'permisoCrear',
        component: PermisoCrearAdminComponent
      },
      {
        path: 'permisoAsigna',
        component: PermisoAsignaAdminComponent
      },
      {
        path: 'modulo',
        component: ModulosAdminComponent
      }
    ]
  },
  {
    path: 'gestion',
    component: PrincipalOperarioComponent,
    children: [
      {
        path: '',
        component: BodyOperarioComponent
      },
      {
        path: 'reqGeneral',
        component: ReqGeneralOperarioComponent
      },
      {
        path: 'reqEspecifico',
        component: ReqEspecificoOperarioComponent
      },
      {
        path: 'tipoBecas',
        component: BecasTipoOperarioComponent
      },
      {
        path: 'tipoRequisitos',
        component: RequisitoTipoOperarioComponent
      },
      {
        path: 'becaDetalle',
        component: BecasDetalleOperarioComponent
      },
      {
        path: 'calificaciones',
        component: CalificacionesOperarioComponent
      },
      {
        path: 'promedio',
        component: PromedioOperarioComponent
      },
      {
        path: 'verReqGeneral',
        component: ReqGeneralOperarioVerComponent
      },
      {
        path: 'verReqEspecifico',
        component: ReqEspecificoOperarioVerComponent
      },
      {
        path: 'verPostulantes',
        component: ListaBecariosComponent
      },
      {
        path: 'consultaPSE',
        component: EducativaConsultasComponent
      },
      {
        path: 'ReservaCM',
        component: EducativaReservaComponent
      },
      {
        path: 'ReservaCMLista',
        component: EducativaReservaListaComponent
      },
      {
        path: 'atencionPSE',
        component: EducativaInfAtencionesComponent
      },
      {
        path: 'encuesta',
        component: EncuestaComponent
      },
      {
        path: 'encuestaGrupo',
        component: EncuestaGrupoComponent
      },
      {
        path: 'encuestaPreguntas',
        component: EncuestaPreguntaComponent
      },
      {
        path: 'verResEncuesta',
        component: EncuestaListaRespondeComponent
      },
      {
        path: 'verRespuestaFicha',
        component: EncuestaRespuestaComponent
      },
      {
        path: 'verFichaMatriz',
        component: EncuestaMatrizComponent
      },
      {
        path: 'verFichaReporte',
        component: EncuestaReporteComponent
      },
      {
        path: 'verAdminSimula',
        component: SimuladorAdminARComponent
      },
      {
        path: 'simuladorAR23',
        component: SimuladorAR2023ComponentComponent
      },
      {
        path: 'reporteMatriz',
        component: EncuestaMatrizResultadoComponent
      },
      {
        path: 'reporteAR',
        component: Calificaciones23OperarioComponent
      },
      {
        path: 'reporteAR24',
        component: Calificaciones24OperarioComponent
      },
      {
        path: "socioEconomico",
        component: EstudioSocioEconomicoComponent,
      },
      {
        path: "socioEconomico25",
        component: EstudioSocioEconomico2025Component,
      },
      {
        path: "verSocioEconomico",
        component: EstudioSocioEcRevisaComponent,
      },
      {
        path: "listaSocioEconomico",
        component: EstudioSocioEcListaComponent,
      },
      {
        path: "ajustesTipoBeca",
        component: TipoBecaAjusteComponent,
      },
      {
        path: 'reporteAR25',
        component: Calificaciones25Component
      },
      {
        path: 'simuladorAR25',
        component: SimuladorAr2025Component
      },
      {
        path: 'fichaEstudiantil25',
        component: FichaCustionariosComponent
      },
      {
        path: 'fichaPreguntas25',
        component: FichaPreguntasComponent
      },
      {
        path: 'fichaFaltantes25',
        component: EncuestaListaFaltantesComponent
      }
    ]
  },
  {
    path: 'becario',
    component: PrincipalBecarioComponent,
    children: [
      {
        path: '',
        component: BodyBecarioComponent
      },
      {
        path: 'verBecas',
        component: VerBecasBecarioComponent
      },
      {
        path: 'postulaBecas',
        component: PostulaBecarioComponent
      },
      {
        path: 'verPostula',
        component: PostulaVerBecarioComponent
      },
      {
        path: 'fichaEstudiante',
        component: FichaEstudianteComponent
      },
      {
        path: 'verFichas',
        component: FichaListaComponent
      },
      {
        path: 'verResultado',
        component: FichaRespuestaComponent
      },
      {
        path: 'fichaEditar',
        component: FichaEditarComponent
      },
      {
        path: 'fichaEstudianteResponde',
        component: FichaRespondeEstudianteComponent
      }
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);

/*@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }*/
